import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./PricingSection3.scss";

function PricingSection3(props) {
  const plans = [
    {
      id: "accountable-ai",
      image: "/ai_graphic1_title.svg",
      name: "Accountable AI for Enterprise",
      perks: [
        "Use our platform and our apps to protect your company's IP from unauthorized usage by LLMs and GPT applications",
        "Set your own price and terms of use",
        "Receive royalties for usage (identified/apportioned via output similarity matching)",
      ],
      link: "/accountable-ai"
    },
    {
      id: "API",
      image: "/api_icon_title.svg",
      name: "REST API for developers",
      perks: [
        "Use API to integrate PDS licensing functionality into new and existing applications",
        "Build applications to register and manage data/IP assets",
        "Work with PDS team to plan implementation of data/IP licensing systems",
        "Use libraries, sample code and reference applications to bootstrap and get to POC/MVP quickly ",
      ],
      link: "/developer"
    },
    {
      id: "APP",
      image: "/app_graphic1_title.svg",
      name: "Applications Programming Platform for Enterprise",
      perks: [
        "Use our own hosted applications built on the platform to transform and manage enterprise processes for internal/external data distribution online",
        "Reskin/White-label ready UI for our creator portal (Licenses) and enterprise brand portal (Campaign)",
        "Fully customizable UI for our consumer app (Portfolio)"
      ],
      link: "/apps"
    },
  ];

  return (
    <Section
      id="pricing2"
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
      <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-variable is-4 is-desktop">
          {plans.map((plan, index) => (
            <div
              className="PricingSection2__column column is-one-third-desktop"
              key={index}
            >
              <div className="PricingSection2__card card">
                <div className="PricingSection2__card-content card-content">
                  <div className="PricingSection2__image-container image">
                    <img className="PricingSection2__image"
                      src={plan.image} alt="Logo" 
                    />
                  </div>
                  <br />
                  <div className="PricingSection2__name has-text-weight-bold">
                    {plan.name}
                  </div>

                  {plan.description && (
                    <p className="PricingSection2__description">
                      {plan.description}
                    </p>
                  )}

                  {plan.perks && (
                    <ul className="PricingSection2__perks">
                      {plan.perks.map((perk, index) => (
                        <li key={index}>
                          <i className="fas fa-check has-text-primary" />
                          {perk}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default PricingSection3;
